import React, { useState } from "react";
import { UPDATE_CLIENT } from "../../../api/apiAdmin";
import { toast } from "react-toastify";
import Button from "../../atoms/Button";
import { PropagateLoader } from "react-spinners";
import useModal from "../../../hooks/useModal";
import ModalConfirm from "../../molecules/ModalConfirm";

const ModalBlock = ({ cliente, onClose, refetch }) => {
    const [loading, setLoading] = useState(false);
    const { open, close, isOpen } = useModal();

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const value ={ isAllowed: cliente.isAllowed === true ? false : true };
            await UPDATE_CLIENT(cliente.id, value);
            toast.success("Registro exitoso");
            refetch();
            onClose();
        } catch(error) {
            console.error(error);
            toast.error("Error al registrar");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col justify-center items-center">
            <div className="w-full bg-blue-100 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-2">Motivos para bloquear un cliente:</h3>
                <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                    <li>Tiene deudas activas con una o más empresas.</li>
                    <li>Incumple con la entrega de documentos obligatorios.</li>
                    <li>Hace mal uso de la plataforma (documentos falsos o irrelevantes).</li>
                    <li>Comparte su cuenta con personas no autorizadas.</li>
                    <li>Solicita funciones fuera del alcance de la apliación.</li>
                </ul>
            </div>
            <Button
                bgColor="blue"
                disabled={loading}
                onClick={open}
                text={loading ? <PropagateLoader color="red" /> : cliente.isAllowed ? "Bloquear" : "Desbloquear"}
            />
            {isOpen &&
                <ModalConfirm onClose={close} onConfirm={handleSubmit} eliminacion />
            }
        </div>
    );
};

export default ModalBlock;